import {lazy} from '@aboutyou/lazy-imports';

export const UpdateCampaigns = lazy(() =>
  import('./UpdateCampaigns.eager').then(mod => ({
    default: mod.UpdateCampaigns,
  })),
);
